export const columnsHeadingFontKeys = {
    md: ['Primary/24_-015', null, null, 'Secondary/40_100_-075'],
    lg: ['Primary/40_-05', null, null, 'Primary/56_-105', null, 'Primary/80_-15'],
};
